// src/components/MultiWaferMapCanvas.js (미리보기 전용 최종본)

import React, { useRef, useEffect, useMemo, useCallback } from "react";

export default function MultiWaferMapCanvas({ mapInfo, onMapClick }) {
  const canvasRef = useRef(null);
  const { data } = mapInfo || {};

  const { minX, maxX, minY, maxY } = useMemo(() => {
    if (!data || data.length === 0) return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
    return {
      minX: Math.min(...data.map(d => d.X)), maxX: Math.max(...data.map(d => d.X)),
      minY: Math.min(...data.map(d => d.Y)), maxY: Math.max(...data.map(d => d.Y)),
    };
  }, [data]);

  const sbinColors = useMemo(() => {
    const colors = { 1: "#4caf50" };
    for (let i = 2; i <= 61; i++) { colors[i] = `hsl(${(i * 30) % 360}, 70%, 60%)`; }
    return colors;
  }, []);
  const defaultColor = "#cccccc";
  
  const dataMap = useMemo(() => {
    if (!data) return {}; const map = {}; data.forEach(d => { map[`${d.X},${d.Y}`] = d; }); return map;
  }, [data]);

  const drawCanvas = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas || !data) return;
    
    // ✅ 부모 div의 크기를 가져와서 캔버스 크기를 설정
    const { width, height } = canvas.parentElement.getBoundingClientRect();
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, width, height);
    
    const PADDING = 5;
    const availableWidth = width - PADDING;
    const availableHeight = height - PADDING;
    const numDiesX = maxX - minX + 1;
    const numDiesY = maxY - minY + 1;
    if (availableWidth <= 0 || availableHeight <= 0 || numDiesX <= 0 || numDiesY <= 0) return;
    const cellSize = Math.max(0.1, Math.min(availableWidth / numDiesX, availableHeight / numDiesY));

    const mapTotalWidth = numDiesX * cellSize;
    const mapTotalHeight = numDiesY * cellSize;
    const mapStartX = (width - mapTotalWidth) / 2;
    const mapStartY = (height - mapTotalHeight) / 2;
    
    for (let y = minY; y <= maxY; y++) {
      for (let x = minX; x <= maxX; x++) {
        const point = dataMap[`${x},${y}`];
        const px = mapStartX + (x - minX) * cellSize;
        const py = mapStartY + (y - minY) * cellSize;
        ctx.fillStyle = point ? (sbinColors[point.SBIN] || defaultColor) : "#fff";
        ctx.fillRect(px, py, cellSize, cellSize);
      }
    }
  }, [data, dataMap, maxX, maxY, minX, minY, sbinColors, defaultColor]);

  // data가 변경될 때만 캔버스를 다시 그림
  useEffect(() => {
    drawCanvas();
  }, [drawCanvas, data]);

  return (
    <canvas
      ref={canvasRef}
      onClick={onMapClick}
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', cursor: 'pointer' }}
    />
  );
}